import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ToastService } from '../../../../services/toast.service';
import { Balanca } from '../../../../types/Balanca.type';
import { Produto } from '../../../../types/Produto.type';
import { BalancaConfigService } from './balanca.service';
import { ProdutoConfigService } from './produto.service';

@Component({
  selector: 'app-balanca-config',
  templateUrl: './balanca.component.html',
  styleUrl: './balanca.component.css'
})
export class BalancaConfigComponent implements OnInit {

  // --- Balanças ---
  balancas: Balanca[] = [];
  loading: boolean = true;

  instanciaSelecionada: string = localStorage.getItem('instancia') ?? '';

  displayDialog: boolean = false;
  editando: boolean = false;
  balancaSelecionada: Balanca = this.novaBalanca();
  loadingSalvar: boolean = false;

  // --- Tipo Produto ---
  produtos: Produto[] = [];
  loadingProdutos: boolean = false;

  displayProdutoDialog: boolean = false;
  editandoProduto: boolean = false;
  produtoSelecionado: Produto = this.novoProduto();
  loadingSalvarProduto: boolean = false;

  readonly tiposProduto: string[] = ['ACUCAR', 'ALCOOL', 'OUTROS'];

  constructor(
    private balancaService: BalancaConfigService,
    private produtoService: ProdutoConfigService,
    private toastService: ToastService,
    private confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {
    this.carregarBalancas();
    this.carregarProdutos();
  }

  // --- Balanças CRUD ---

  carregarBalancas(): void {
    this.loading = true;
    this.balancaService.findAll().subscribe({
      next: (data) => {
        this.balancas = data;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar balanças: ' + (error?.error?.message ?? error.message));
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  novaBalanca(): Balanca {
    return { canal: '', modelo: '', descricao: '', ip_balanca: '', porta_balanca: 0, permite_digitacao_manual: false };
  }

  abrirNovo(): void {
    this.balancaSelecionada = this.novaBalanca();
    this.balancaSelecionada.instancia = this.instanciaSelecionada;
    this.editando = false;
    this.displayDialog = true;
  }

  abrirEditar(balanca: Balanca): void {
    this.balancaSelecionada = { ...balanca };
    this.editando = true;
    this.displayDialog = true;
  }

  fecharDialog(): void {
    this.displayDialog = false;
    this.balancaSelecionada = this.novaBalanca();
    this.loadingSalvar = false;
  }

  salvar(): void {
    if (!this.balancaSelecionada.modelo || !this.balancaSelecionada.ip_balanca || !this.balancaSelecionada.porta_balanca) {
      this.toastService.erro('Validação', 'Preencha os campos obrigatórios: Modelo, IP da Balança e Porta.');
      return;
    }
    this.loadingSalvar = true;
    if (this.editando && this.balancaSelecionada.id) {
      this.balancaService.update(this.balancaSelecionada.id, this.balancaSelecionada).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Balança atualizada com sucesso');
          this.fecharDialog();
          this.carregarBalancas();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao atualizar balança: ' + (error?.error?.message ?? error.message));
          this.loadingSalvar = false;
        }
      });
    } else {
      this.balancaService.create(this.balancaSelecionada).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Balança criada com sucesso');
          this.fecharDialog();
          this.carregarBalancas();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao criar balança: ' + (error?.error?.message ?? error.message));
          this.loadingSalvar = false;
        }
      });
    }
  }

  confirmarExclusao(balanca: Balanca, event: Event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Deseja realmente excluir a balança "${balanca.modelo}"?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => this.excluir(balanca)
    });
  }

  excluir(balanca: Balanca): void {
    if (!balanca.id) return;
    this.balancaService.delete(balanca.id).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Balança excluída com sucesso');
        this.carregarBalancas();
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao excluir balança: ' + (error?.error?.message ?? error.message));
      }
    });
  }

  // --- Tipo Produto CRUD ---

  carregarProdutos(): void {
    this.loadingProdutos = true;
    this.produtoService.findAll().subscribe({
      next: (data) => {
        this.produtos = data;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar produtos: ' + (error?.error?.message ?? error.message));
      },
      complete: () => {
        this.loadingProdutos = false;
      }
    });
  }

  novoProduto(): Produto {
    return { codigo: '', balanca_entrada_id: undefined, balanca_saida_id: undefined };
  }

  abrirNovoProduto(): void {
    this.produtoSelecionado = this.novoProduto();
    this.produtoSelecionado.instancia = this.instanciaSelecionada;
    this.editandoProduto = false;
    this.displayProdutoDialog = true;
  }

  abrirEditarProduto(produto: Produto): void {
    this.produtoSelecionado = { ...produto };
    this.editandoProduto = true;
    this.displayProdutoDialog = true;
  }

  fecharProdutoDialog(): void {
    this.displayProdutoDialog = false;
    this.produtoSelecionado = this.novoProduto();
    this.loadingSalvarProduto = false;
  }

  salvarProduto(): void {
    if (!this.produtoSelecionado.codigo) {
      this.toastService.erro('Validação', 'Selecione o tipo de produto.');
      return;
    }
    this.loadingSalvarProduto = true;
    if (this.editandoProduto && this.produtoSelecionado.id) {
      this.produtoService.update(this.produtoSelecionado.id, this.produtoSelecionado).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Vínculo de produto atualizado com sucesso');
          this.fecharProdutoDialog();
          this.carregarProdutos();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao atualizar vínculo: ' + (error?.error?.message ?? error.message));
          this.loadingSalvarProduto = false;
        }
      });
    } else {
      this.produtoService.create(this.produtoSelecionado).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Vínculo de produto criado com sucesso');
          this.fecharProdutoDialog();
          this.carregarProdutos();
        },
        error: (error) => {
          this.toastService.erro('Erro', 'Erro ao criar vínculo: ' + (error?.error?.message ?? error.message));
          this.loadingSalvarProduto = false;
        }
      });
    }
  }

  confirmarExclusaoProduto(produto: Produto, event: Event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Deseja realmente excluir o vínculo do produto "${produto.codigo}"?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => this.excluirProduto(produto)
    });
  }

  excluirProduto(produto: Produto): void {
    if (!produto.id) return;
    this.produtoService.delete(produto.id).subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', 'Vínculo excluído com sucesso');
        this.carregarProdutos();
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao excluir vínculo: ' + (error?.error?.message ?? error.message));
      }
    });
  }

  getNomeBalanca(id?: string): string {
    if (!id) return '—';
    const b = this.balancas.find(b => b.id === id);
    return b ? b.modelo : '—';
  }

  get balancasDoProduto(): Balanca[] {
    const instancia = this.produtoSelecionado.instancia;
    if (!instancia) return this.balancas;
    return this.balancas.filter(b => b.instancia === instancia);
  }

  get opcoesInstanciaBalanca(): string[] {
    return [...new Set(this.balancas.map(b => b.instancia).filter(Boolean) as string[])].sort();
  }

  get opcoesInstanciaProduto(): string[] {
    return [...new Set(this.produtos.map(p => p.instancia).filter(Boolean) as string[])].sort();
  }

}
